module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./AiAgentShortcutView.js"));
	}, "AiAgentShortcutView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AiAgentShortcutView!./src/pages/AiAgentShortcut/AiAgentShortcutView.js
// module id = 1271
// module chunks = 438